import { Link } from 'react-router-dom';
import type { Team } from '@/types';

interface Props {
  team?: Team;
  size?: 'sm' | 'md' | 'lg';
  to?: string;
}

const sizeMap = {
  sm: 'w-8 h-8 text-[10px]',
  md: 'w-11 h-11 text-xs',
  lg: 'w-16 h-16 text-sm',
};

export default function TeamBadge({ team, size = 'md', to }: Props) {
  if (!team) return null;
  const badge = (
    <span
      className={`${sizeMap[size]} rounded-full flex items-center justify-center font-heading font-bold tracking-tight text-white shrink-0`}
      style={{ backgroundColor: team.color }}
      aria-hidden="true"
    >
      {team.short}
    </span>
  );
  if (to) {
    return (
      <Link to={to} className="shrink-0 cursor-pointer">
        {badge}
      </Link>
    );
  }
  return badge;
}